import React from 'react';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import img1 from './Balck beauty.jpg'
import img2 from './MUSHTANG TEMPLET.jpg'
import img3 from './SKSWEET.jpg'
import img4 from './SWEET 2.jpg'
import img5 from './brightneescontest color correction.jpg'
import img6 from './color scling color correction.jpg'
import img7 from './eyedrop Lelve.jpg'
import img8 from './glory tap.jpg'
import img9 from './hole nature.jpg'
import img10 from './mouthen.jpg'
import img11 from './nike shose.jpg'
import img12 from './project 1.jpg'
import img13 from './raw image 1.jpg'
import img14 from './raw image 3.jpg'
import img15 from './raw image 4.jpg'
import img16 from './raw image 5.jpg'
import img17 from './raw image2.jpg'
import img18 from './rolex.jpg'
import img19 from './90s-Style-Mens-Clothing copy.jpg'
import img20 from './BANANA typography.jpg'
import img21 from './Untitled-1.jpg'
import img22 from './Text Liduify.jpg'
import './photoshop.css'



export function Photoshop(){
    return(
        <div className='bg-dark'>
            <div className='container-fluid'>
                <div className='row  '>
        <img src={img9} className='col-lg-12 mt-3 imghover'/>
        <img src={img1} className='col-lg-4 mt-3 imghover'/>
        <img src={img4} className='col-lg-4 mt-3 imghover'/>
        <img src={img3} className='col-lg-4 mt-3 imghover'/>
        <img src={img2} className='col-lg-4 mt-3 imghover'/>
        <img src={img5} className='col-lg-4 mt-3 imghover'/>
        <img src={img6} className='col-lg-4 mt-3 imghover'/>
        <img src={img7} className='col-lg-4 mt-3 imghover'/>
        <img src={img12} className='col-lg-8 mt-3 imghover'/>
        <img src={img8} className='col-lg-8 mt-3 imghover'/>
        <img src={img13} className='col-lg-4 mt-3 imghover'/>
        <img src={img14} className='col-lg-8 mt-3 imghover'/>
        <img src={img15} className='col-lg-6 mt-3 imghover'/>
        <img src={img16} className='col-lg-6 mt-3 imghover'/>
        <img src={img17} className='col-lg-6 mt-3 imghover'/>
        <img src={img18} className='col-lg-4 mt-3 imghover'/>
        <img src={img11} className='col-lg-6 mt-3 imghover'/>
        <img src={img10} className='col-lg-6 mt-3 imghover'/>
        <img src={img19} className='col-lg-6 mt-3 imghover'/>
        <img src={img20} className='col-lg-6 mt-3 imghover'/>
        <img src={img21} className='col-lg-12 mt-3 imghover'/>
        <img src={img22} className='col-lg-6 mt-3 imghover'/>
        
       
        </div>
        </div>
</div>
    )
   
    }